import {
  intlShape,
  DynamicFieldArray,
  ContextualHelp,
  withIntl,
} from "lcm-iot-commons";

import { FieldGatewayModbusChannelSelect } from "./FieldGatewayModbusChannelSelect";
import { FieldGatewayModbusVariableSelect } from "./FieldGatewayModbusVariableSelect";
import { FieldGatewayModbusValueTextInput } from "./FieldGatewayModbusValueTextInput";

type OwnProps = {
  intl: intlShape;
  disabled?: boolean;
  isSubmitting?: boolean;
};

const defaultProps: Partial<OwnProps> = {
  disabled: false,
  isSubmitting: false,
};

type Props = OwnProps & typeof defaultProps;

export function FieldGatewaySpecificationsInput(props: Props) {
  const { intl, disabled, isSubmitting } = props;
  return (
    <>
      <label
        htmlFor="Modbus Configuration"
        data-testid="modbus-config-specifications-input"
      >
        {intl.formatMessage({
          id: "field_gateway.modbus.config.item.ai_di_channel",
        })}
      </label>
      <ContextualHelp
        title={intl.formatMessage({
          id: "field_gateway.modbus.config.edit.help",
        })}
      >
        <p>
          {intl.formatMessage({
            id: "field_gateway.modbus.config.edit.description.line1",
          })}
          <br />
          {intl.formatMessage({
            id: "field_gateway.modbus.config.edit.description.line2",
          })}
          <br />
          {intl.formatMessage({
            id: "field_gateway.modbus.config.edit.description.line3",
          })}
          <br />
          {intl.formatMessage({
            id: "field_gateway.modbus.config.edit.description.line4",
          })}
          <br />
          {intl.formatMessage({
            id: "field_gateway.modbus.config.edit.description.line5",
          })}
          <br />
          {intl.formatMessage({
            id: "field_gateway.modbus.config.edit.description.line6",
          })}
        </p>
      </ContextualHelp>
      <DynamicFieldArray
        {...props}
        // @ts-expect-error TS(2322) FIXME: Type '{ id: string; valueArrayName: string; placeh... Remove this comment to see the full error message
        id="gateway-specifications"
        valueArrayName="modbusConfig"
        placeholders={[
          intl.formatMessage({
            id: "field_gateway.modbus.config.item.valuename",
          }),
          intl.formatMessage({
            id: "field_gateway.modbus.config.item.channel",
          }),
          intl.formatMessage({
            id: "field_gateway.modbus.config.item.variable",
          }),
        ]}
        colSizeArray={[6, 2, 2]}
        fieldNames={["valueName", "channel", "regName"]}
        fieldComponents={[
          FieldGatewayModbusValueTextInput,
          FieldGatewayModbusChannelSelect,
          FieldGatewayModbusVariableSelect,
        ]}
        disabled={disabled || isSubmitting}
      />
    </>
  );
}

FieldGatewaySpecificationsInput.defaultProps = defaultProps;

export default withIntl(FieldGatewaySpecificationsInput);
